import { render } from "./priceList.vue?vue&type=template&id=e0eff18e&scoped=true"
import script from "./priceList.vue?vue&type=script&lang=js"
export * from "./priceList.vue?vue&type=script&lang=js"

import "./priceList.vue?vue&type=style&index=0&id=e0eff18e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0eff18e"]])

export default __exports__